// ABOUTME: Version information for the HITL UI
// ABOUTME: Automatically populated from Azure DevOps pipeline build number or npm script

// APP_BUILD_NUMBER format:
// - Pipeline: YYYYMMDD.buildAttemptNumber (e.g., "20251110.63")
// - Local dev: YYYYMMDD.dev-GITHASH (e.g., "20251110.dev-2987227")
// - Fallback: "dev-local" if environment variable not set
export const APP_BUILD_NUMBER = process.env.APP_BUILD_NUMBER || "dev-local";
